import { createSelector } from 'reselect';
import { getWorkOrderManagement } from './getWorkOrderManagement';
import { getIsInitialActivitySetPollLoading } from './getIsInitialActivitySetPollLoading';

const getLoadingCurrentWorkOrderOp = createSelector(
  [getWorkOrderManagement, getIsInitialActivitySetPollLoading],
  (workOrderManagement, isInitialActivitySetPollLoading) => {
    // We're loading currentWorkOrderOp if:
    // 1. The workOrderOp query itself is loading, OR
    // 2. We're still loading activity sets (which contain the workOrderOperationRef needed for the query)
    return (
      workOrderManagement?.loadingCurrentWorkOrderOp ||
      isInitialActivitySetPollLoading
    );
  }
);

export { getLoadingCurrentWorkOrderOp };
